import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReorderModule } from '../../cart/reorder/reorder.module';
import { MyAccountPermissionsAuthGuard } from '../../myaccount/guards/myaccount-permissions-auth.guard';
import { ShimanoPaginationModule } from '../../pagination/pagination.module';
import { SortingModule } from '../../sorting/sorting.module';
import { TooltipTextModule } from '../../tooltip-text/tooltip-text.module';
import { OrderHistoryFilterModule } from './order-history-filter/order-history-filter.module';
import { OrderHistoryInvoiceComponent } from './order-history-invoice/order-history-invoice.component';
import { OrderHistoryComponent } from './order-history.component';

@NgModule({
  declarations: [OrderHistoryComponent, OrderHistoryInvoiceComponent],
  imports: [
    CommonModule,
    I18nModule,
    MatIconModule,
    MatTooltipModule,
    RouterModule,
    UrlModule,
    OrderHistoryFilterModule,
    ShimanoPaginationModule,
    SortingModule,
    ReorderModule,
    FormsModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MediaModule,
    InfiniteScrollModule,
    MatProgressSpinnerModule,
    SharedModule,
    TooltipTextModule,
  ],
  exports: [OrderHistoryInvoiceComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        AccountOrderHistoryFlexComponent: {
          component: OrderHistoryComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [MyAccountPermissionsAuthGuard],
        },
      },
    }),
  ],
})
export class OrderHistoryModule {}
